import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import fiFI from './locales/fi.json'
import svSE from './locales/sv.json'
import enUS from './locales/en.json'

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      fi: { translation: fiFI },
      sv: { translation: svSE },
      en: { translation: enUS },
    },
    fallbackLng: 'fi',
    debug: process.env.NODE_ENV === 'development',
    interpolation: {
      escapeValue: false, // React already escapes
    },
    detection: {
      order: ['localStorage' /*, 'navigator'*/], // 'navigator' disabled — defaults to Finnish (fallbackLng)
      caches: ['localStorage'],
    },
  })

export default i18n
